import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/Accordion.module.scss';
import { clickTracker, getPaymentsSubEventType, getProjectId } from '../../lib/common';
import { handleShowTagsFeedback } from '../../reducersAndActions/actions/appStateActions';
import { useAppState } from '../../contexts/appState';
import { handleImpressionsTrack } from '../../api';
import { useAuth } from '../../contexts/auth';

export default function FaqFeedback({
  faq,
  helpful,
  setHelpful,
  setShowData,
  faqsFeedbackData,
  setFaqsFeedbackData,
  id,
}) {
  const [, appDispatch] = useAppState();
  const [authState] = useAuth();
  const projectId = getProjectId();

  useEffect(() => {
    const handleStoredFeedbackData = () => {
      const storedFeedbackData = sessionStorage.getItem('paymentsFaqsFeedback');
      if (storedFeedbackData) {
        setFaqsFeedbackData(JSON.parse(sessionStorage.getItem('paymentsFaqsFeedback')));
      }
    };
    handleStoredFeedbackData();
  }, []);
  const handleisHelpful = async (index, faqKey, faqId) => {
    const storeKey = id === 'editListingPage' ? 10 : faqId;
    setFaqsFeedbackData((prevData) => ({
      ...prevData,
      [storeKey]: index === 0 ? 'Helpful' : 'NotHelpful',
    }));

    sessionStorage.setItem(
      'paymentsFaqsFeedback',
      JSON.stringify({ ...faqsFeedbackData, [storeKey]: index === 0 ? 'Helpful' : 'NotHelpful' }),
    );

    setHelpful((prevObj) =>
      prevObj.map((each) => (each.id === index ? { ...each, isActive: true } : { ...each, isActive: false })),
    );

    setShowData(index === 0);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `faq_${index === 0 ? 'helpful' : 'nothelpful'}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_${id === 'editListingPage' ? 'editBusiness' : id}`;
      const llTrdInside = `faq_${id === 'editListingPage' ? 'managebusinessprofile' : faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
    if (index === 1 && projectId === 'csportal' && id !== 'editListingPage') {
      handleShowTagsFeedback(appDispatch, { status: true, question: faq?.question || '' });
    }

    if (id === 'payments') {
      await clickTracker(
        `FAQ_${getPaymentsSubEventType?.[faqId]}_${index === 0 ? 'yes' : 'no'}`,
        projectId === 'csportal' ? 'payments_FAQ_feedback' : 'geniocs_payments_faq_feedback',
      );
    }
    if (id === 'contract') {
      const feedbackType =
        projectId === 'csportal'
          ? 'contract_FAQ_feedback'
          : projectId === 'genio'
            ? 'genio_contract_FAQ_feedback'
            : null;
      await clickTracker(`FAQ_${faq?.faqKey}_${index === 0 ? 'yes' : 'no'}`, feedbackType);
    }

    if (id === 'editBusiness') {
      await clickTracker(`FAQ_${faq?.faqKey}_${index === 0 ? 'yes' : 'no'}`, 'editdata_FAQ_feedback');
    }
  };

  return (
    <div className={`${styles.Accordion__Helpful} mt-15 mb-10`}>
      <div className="font11 fw400 color777 mr-10">Was this Helpful?</div>
      {helpful &&
        helpful.map((item) => (
          <div
            key={item.id}
            aria-label="isHelpful_click"
            tabIndex={0}
            role="button"
            onKeyDown={() => {}}
            onClick={() => {
              handleisHelpful(item.id, faq.faqKey, faq.pop);
            }}
            className={`${item?.icon} ${
              item?.isActive ||
              (item.id === 0 && faqsFeedbackData[faq.pop] === 'Helpful') ||
              (item.id === 1 && faqsFeedbackData[faq.pop] === 'NotHelpful') ||
              (id === 'editListingPage' && item.id === 0 && faqsFeedbackData[10] === 'Helpful') ||
              (id === 'editListingPage' && item.id === 1 && faqsFeedbackData[10] === 'NotHelpful')
                ? styles.Active
                : ''
            } csicon mr-10`}
          />
        ))}
    </div>
  );
}

FaqFeedback.propTypes = {
  faq: PropTypes.object,
  helpful: PropTypes.array,
  setHelpful: PropTypes.func,
  setShowData: PropTypes.func,
  faqsFeedbackData: PropTypes.object,
  setFaqsFeedbackData: PropTypes.func,
  id: PropTypes.string,
};
